import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const fetchSharePremiumService = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_SHARE_PREMIUM_SERVICE,
        payload: {
            data: data
        }
    }
};

export const fetchSharePremiumServiceSuccess = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_SHARE_PREMIUM_SERVICE_SUCCESS,
    }
};

export const fetchSharePremiumServiceError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_SHARE_PREMIUM_SERVICE_FAILURE,
        payload: {
            data: error
        }
    }
};

export const resetSharePremiumService = (): FluxStandardAction => {
    return {
        type: Actions.RESET_SHARE_PREMIUM_SERVICE,
    }
};


export const fetchShareUrlContentAction = (psName: string) => {
    return {
        type: Actions.FETCH_SHARE_URL_CONTENT,
        payload: {
            data: {
                psName: psName
            }
        }
    }
};

export const fetchShareUrlContentSuccessAction = (content: any) => {
    return {
        type: Actions.FETCH_SHARE_URL_CONTENT_SUCCESS,
        payload: {
            data: content
        }
    }
};

export const fetchShareUrlContentFailureAction = (error: any) => {
    return {
        type: Actions.FETCH_SHARE_URL_CONTENT_FAILURE,
        payload: {
            data: error
        }
    }
};